import { GAListInfo } from "../types";
import {
  mapProductTileToGtagItem,
  sendViewItemListEvent,
  sendSelectItemEvent,
  saveItemListContext,
} from "./analytics/google-analytics";

export function sendImpressionsForProductTiles(tiles: HTMLElement[]) {
  if (tiles.length === 0) return;
  const parent = tiles[0].parentNode as HTMLElement;
  if (!parent) return;

  const siblings = Array.from(parent.childNodes)
    .filter((node): node is Element => node.nodeType === 1)
    .filter((node) => !node.classList.contains("glide__slide--clone"));

  const { listId, listName, listCategory, searchTerm } = getListInfo(parent);

  const customDimensions = {
    ...(listCategory && { category_name: listCategory }),
    ...(searchTerm && { search_term: searchTerm }),
  };

  // Send Impressions as view_item_list to GoogleAnalytics
  // Attach click handlers to select_item too
  const gaItems = tiles
    .map((tile) => {
      if (shouldSendImpression(tile) === false) return;
      const index = siblings.indexOf(tile);
      const item = mapProductTileToGtagItem(tile, index);

      if (listId && listName && item) {
        tile.addEventListener("click", () => {
          if (item.item_id) saveItemListContext(item.item_id, listId, listName);

          sendSelectItemEvent(listId, listName, [item], customDimensions);
        });
      }

      tile.classList.add("impression-sent");

      return item;
    })
    .filter(Boolean) as Gtag.Item[];

  if (gaItems.length > 0) {
    if (listId && listName) {
      sendViewItemListEvent(listId, listName, gaItems, customDimensions);
    }
  }
}

export function getListInfo(parent: HTMLElement): GAListInfo {
  let container = parent.closest(".products-list") as HTMLElement; // Product Page List
  if (!container) container = parent.closest(".carousel") as HTMLElement; // Carousel

  const { listId, listName, listCategory, searchTerm } =
    container?.dataset ?? {};
  return { listId, listName, listCategory, searchTerm };
}

function shouldSendImpression(tile: HTMLElement) {
  // already sent in some previous call
  return !tile.classList.contains("impression-sent");
}

export function createProductImpressionObserver() {
  return new IntersectionObserver(
    (entries) => {
      const items: HTMLElement[] = [];
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        items.push(entry.target as HTMLElement);
      });
      sendImpressionsForProductTiles(items);
    },
    { threshold: [0.5] }
  );
}
